<template>
  <div class="input-container location">
                <input
                    type="text"
                    class="input"
                    placeholder="Enter current location"
                />
                <img
                    src="../assets/mapPin.svg"
                    alt="map pin"
                    class="mapPin"
                />
            </div>
</template>

<script setup></script>